const {
  fetchBrowsingContext,
  getCookie,
  setCookie,
  shippingCountries,
} = window.BAO.Utils

function revealCookieBanner () {
  let timeout = 0
  if (!document.querySelector('#onetrust-consent-sdk')) timeout = 500
  setTimeout(() => {
    const onetrustConsentSdkEl = document.querySelector('#onetrust-consent-sdk')
    if (!onetrustConsentSdkEl) return

    onetrustConsentSdkEl.style.display = 'block'
  }, timeout)
}

/**
 * @note There's quite a lot of duplicated logic in this script. I've added `getLocationFromCookie`
 * and `getLocationFromUrl` methods which should in theory allow us to reduce a lot of duplication,
 * but I've not been able to replace and test each one. - DW
 */

/**
 * @typedef {Object} ShippingLocation
 *
 * @property {string} code
 * @property {string} currency
 * @property {string} name
 * @property {string} site
 */

function getRedirectUrl (site, region, currency) {
  const stores = {
    EU: 'https://eu.thefrankieshop.com/',
    US: 'https://thefrankieshop.com',
  }

  const url = `${stores[site]}?country=${region}&region=${region}`

  return url
}

class ShippingLocationModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['select']
  }

  async connectedCallback () {
    super.connectedCallback()

    const {
      detected_values: { country: { handle = '' } } = {},
    } = await fetchBrowsingContext()
    this.detectedIso2Code = handle

    /** @type {HTMLSelectElement[]} */
    this.subscribedExternalSelectors = []

    this.connectExternalSelector(this.externalEls.footerSelect.element)
    this.connectExternalSelector(this.externalEls.mobileNavSelect.element)

    const stores = {
      EU: 'https://eu.thefrankieshop.com',
      US: 'https://thefrankieshop.com',
    }

    // If cookie is already set and is not the same store direct customer to cookie website

    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    } else if (getCookie('fs-geo')) {
      const cookie = JSON.parse(getCookie('fs-geo'))
      const cookieLocation = shippingCountries().find(
        country => country.code === cookie.value,
      )

      const cookieSetStore = new URL(
        getRedirectUrl(cookieLocation.site, cookieLocation.code),
      )

      const region = new URL(window.location).searchParams.get('region')
      const queryLocation = shippingCountries().find(
        country => country.code === region,
      )

      let querySetStore
      if (this.checkIfSearchParamsExist()) {
        querySetStore = new URL(
          getRedirectUrl(queryLocation.site, queryLocation.code),
        )
      } else {
        querySetStore = {
          origin: '',
        }
      }

      if (cookieSetStore.origin !== window.location.origin) {
        if (querySetStore.origin !== window.location.origin) {
          window.location.href = this.buildRedirectUrl(cookieLocation)
        }
      } else if (
        cookieLocation.markets &&
        !cookieLocation.markets.some(locale =>
          window.location.href.includes(locale),
        )
      ) {
        window.location.href = this.buildRedirectUrl(cookieLocation)
      }
    }
    // End //

    if (this.checkIfSearchParamsExist()) {
      const region = new URL(window.location).searchParams.get('region')
      const location = shippingCountries().find(
        country => country.code === region,
      )

      this.subscribedExternalSelectors.forEach(selector => {
        selector.value = location.code
      })

      if (
        new URL(getRedirectUrl(location.site, location.code)).origin !==
        new URL(window.location).origin
      ) {
        window.location.href = this.buildRedirectUrl(location)
      }
    }

    if (new URL(window.location).pathname.includes('/products_preview')) return

    const urlParams = new URLSearchParams(window.location.search)

    if (urlParams.get('region')) {
      const stores = {
        EU: 'https://eu.thefrankieshop.com',
        US: 'https://thefrankieshop.com',
      }

      const region = new URL(window.location).searchParams.get('region')
      const location = shippingCountries().find(
        country => country.code === region,
      )

      if (window.location.origin === stores[location.site]) {
        revealCookieBanner()

        this.setGeoCookie(location)
      }
    } else if (this.checkIfCookieIsSet()) {
      this.assignValuesToFormElements(JSON.parse(getCookie('fs-geo')).value)

      this.subscribedExternalSelectors.forEach(selector => {
        selector.value = JSON.parse(getCookie('fs-geo')).value
      })

      revealCookieBanner()

      return
    } else {
      const selectedCountry = shippingCountries().find(
        country => country.code === this.detectedIso2Code,
      )

      if (stores[selectedCountry.site] !== window.location.origin) {
        this.showModal()
      }
    }

    this.buildShippingOptions(this.els.select.element)

    if (getCookie('fs-geo') !== '') return

    const selectedCountry = shippingCountries().find(
      country => country.code === this.detectedIso2Code,
    )

    if (stores[selectedCountry.site] === window.location.origin) {
      revealCookieBanner()
    }

    this.assignValuesToFormElements(selectedCountry.code)

    this.els.select.element.addEventListener(
      'change',
      this.onSelectChange.bind(this),
    )

    this.els.form.element.addEventListener(
      'submit',
      this.onSubmission.bind(this),
    )

    this.trapFocus()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.body,
      'shipping-location:request-connect',
      this.handleConnectRequest.bind(this),
    )
  }

  /** @param {CustomEvent<{ select: HTMLSelectElement }>} event */
  handleConnectRequest (event) {
    this.connectExternalSelector(event.detail.select)
  }

  /** @param {HTMLSelectElement} selector */
  connectExternalSelector (selector) {
    this.buildShippingOptions(selector)

    this.listeners.add(
      selector,
      'change',
      this.onExternalSelectChange.bind(this),
    )

    const location = this.getCurrentLocation()
    if (location) {
      selector.value = location.code
    }

    this.subscribedExternalSelectors.push(selector)

    this.getCurrentLocation()
  }

  getLocationFromCookie () {
    const geoCookie = getCookie('fs-geo')

    if (!geoCookie) {
      return
    }

    const cookie = JSON.parse(geoCookie)
    return shippingCountries().find(country => country.code === cookie.value)
  }

  getLanguageFromCookie () {
    const geoCookie = getCookie('fs-geo')
    if (!geoCookie) return

    try {
      return JSON.parse(geoCookie).language
    } catch (error) {}
  }

  getLocationFromUrl () {
    const region = new URL(window.location).searchParams.get('region')
    const location = shippingCountries().find(
      country => country.code === region,
    )

    return location
  }

  getCurrentLocation () {
    const locationFromCookie = this.getLocationFromCookie()

    if (locationFromCookie) {
      return locationFromCookie
    }

    const locationFromUrl = this.getLocationFromUrl()

    if (locationFromUrl) {
      return locationFromUrl
    }

    const selectValue = this.els.select.element.value
    return shippingCountries().find(country => {
      return country.code === selectValue
    })
  }

  async forceRedirect () {
    const selectedCountry = shippingCountries().find(
      country => country.code === this.detectedIso2Code,
    )

    const location = selectedCountry
    const storeLocalToCustomer = new URL(
      getRedirectUrl(location.site, location.code),
    )
    const currentStore = new URL(window.location)

    if (
      storeLocalToCustomer.host !== currentStore.host ||
      location.code !== window.Shopify.country
    ) {
      window.location.href = this.buildRedirectUrl(location)
      this.setGeoCookie(location)
      this.hideModal(true)
    } else {
      this.setGeoCookie(location)
      this.hideModal()
    }
  }

  /** @param {Event} event */
  onExternalSelectChange (event) {
    const select = event.currentTarget

    const selectedCountry = shippingCountries().find(
      country => country.code === select.value,
    )

    this.setGeoCookie(selectedCountry)

    window.location.href = this.buildRedirectUrl(selectedCountry)
  }

  onSelectChange (event) {
    this.assignValuesToFormElements(event.target.value)
  }

  onSubmission (event) {
    event.preventDefault()
    this.redirectCustomerOrSetCookie(this.els.select.element)
  }

  redirectCustomerOrSetCookie (element) {
    const selectedCountry = shippingCountries().find(
      country => country.code === element.value,
    )

    const location = selectedCountry
    const storeLocalToCustomer = new URL(
      getRedirectUrl(location.site, location.code),
    )
    const currentStore = new URL(window.location)

    if (
      storeLocalToCustomer.host !== currentStore.host ||
      location.code !== window.Shopify.country
    ) {
      window.location.href = this.buildRedirectUrl(location)
      this.setGeoCookie(location)
      this.hideModal(true)
    } else {
      this.setGeoCookie(location)
      this.hideModal()
    }
  }

  detectLanguage (location) {
    if (!location?.languages) return

    const supported = Object.keys(location.languages)
    const browserLangs = navigator.languages || [navigator.language]

    for (const browserLang of browserLangs) {
      const code = browserLang.split('-')[0].toLowerCase()
      const match = supported.find(lang => lang.toLowerCase() === code)
      if (match) return match
    }

    return supported[0]
  }

  buildRedirectUrl (location) {
    const redirectUrl = new URL(getRedirectUrl(location.site, location.code))

    const cookieLanguage = this.getLanguageFromCookie()
    const language =
      cookieLanguage && location.languages?.[cookieLanguage]
        ? cookieLanguage
        : this.detectLanguage(location)

    let pathname = window.location.pathname

    if (language && location.languages) {
      const marketPath = `/${location.languages[language]}`
      pathname = pathname.replace(/^\/[a-z]{2}-[a-z]{2}/i, '')
      pathname = `${marketPath}${pathname}`
    }

    return `${redirectUrl.origin}${pathname}${redirectUrl.search}`
  }

  setGeoCookie (location) {
    const language = this.detectLanguage(location)

    setCookie(
      'fs-geo',
      JSON.stringify({
        value: location.code,
        name: location.name,
        site: location.site,
        language,
      }),
      14,
    )
  }

  checkIfSearchParamsExist () {
    return new URL(window.location).searchParams.get('region')
  }

  checkIfCookieIsSet () {
    return getCookie('fs-geo')
  }

  showModal () {
    this.setAttribute('aria-hidden', false)
    this.setAttribute('aria-expanded', true)
    document.body.classList.add('util-SiteOverflowed')

    this.els.submit.element.focus()
  }

  hideModal (isRedirect = false) {
    this.setAttribute('aria-hidden', true)
    this.setAttribute('aria-expanded', false)
    document.body.classList.remove('util-SiteOverflowed')

    if (!isRedirect) {
      revealCookieBanner()
    }
  }

  buildShippingOptions (selectEl) {
    const options = shippingCountries()

    options.forEach(option => {
      const currency = option.currency
      const optionHTML = document.createElement('option')
      optionHTML.value = option.code
      optionHTML.text = `${option.name} ${currency}`
      selectEl.appendChild(optionHTML)
    })
  }

  assignValuesToFormElements (selectValue) {
    this.els.select.element.value = selectValue

    this.subscribedExternalSelectors.forEach(selector => {
      selector.value = selectValue
    })
  }

  trapFocus () {
    const focusableEls = this.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
    )
    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9

    this.addEventListener('keydown', e => {
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    })
  }
}

if (!customElements.get('shipping-location-modal')) {
  customElements.define('shipping-location-modal', ShippingLocationModal)
}
